import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { colors } from '../../constants/theme';
import { CATEGORIES, CATEGORY_LABELS } from '../../constants/categories';
import GroupTable from '../Common/GroupTable';

const AUTO_REFRESH_MS = 15000;

/**
 * Classificação dos grupos para o organizador, com atualização automática.
 * Reaproveita a mesma GroupTable da visão pública, então o que o organizador vê
 * é exatamente o que o público vê.
 */
export default function StandingsView() {
  const [category, setCategory] = useState(CATEGORIES[0]);
  const [refreshSignal, setRefreshSignal] = useState(0);
  const [lastUpdate, setLastUpdate] = useState(null);

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap justify-between items-center gap-3">
        <h2 className="text-xl font-bold" style={{ color: colors.primary }}>
          Classificação dos Grupos
        </h2>
        <div className="flex items-center gap-3">
          {lastUpdate && (
            <span className="text-xs text-gray-500">
              Atualizado às {lastUpdate.toLocaleTimeString('pt-BR')}
            </span>
          )}
          <button
            onClick={() => setRefreshSignal((n) => n + 1)}
            className="flex items-center gap-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-sm"
          >
            <RefreshCw className="h-4 w-4" />
            Atualizar
          </button>
        </div>
      </div>

      <p className="text-sm text-gray-600">
        Atualiza sozinha a cada {AUTO_REFRESH_MS / 1000} segundos conforme as partidas
        são finalizadas.
      </p>

      <div className="flex flex-wrap gap-2">
        {CATEGORIES.map((cat) => (
          <button
            key={cat}
            onClick={() => setCategory(cat)}
            className={`px-4 py-2 rounded-lg font-medium ${
              category === cat ? 'text-white' : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
            style={{ backgroundColor: category === cat ? colors.primary : 'white' }}
          >
            {CATEGORY_LABELS[cat]}
          </button>
        ))}
      </div>

      <div className="bg-gray-50 border rounded-lg p-3 space-y-1.5 text-sm">
        <p className="text-green-800">
          <span className="font-bold">✓</span> classificado direto pelo grupo. Grupos
          de 5 atletas classificam 3; grupos de 4 classificam 2.
        </p>
        <p className="text-amber-800">
          <span className="font-bold">✓?</span> está pegando a vaga da repescagem{' '}
          <strong>neste momento</strong>. Compara os 3ºs colocados dos grupos de 4 e
          muda a cada partida encerrada — só vale de verdade quando toda a categoria
          terminar.
        </p>
      </div>

      <GroupTable
        category={category}
        refreshIntervalMs={AUTO_REFRESH_MS}
        refreshSignal={refreshSignal}
        onRefreshed={setLastUpdate}
      />
    </div>
  );
}
